import { ArrowDropDown, DeleteSharp, FileDownloadOutlined, SpatialAudioOff } from "@mui/icons-material";
import { Box, Button, ButtonGroup, Divider, Menu, Typography } from "@mui/material";
import { useState } from "react";
import CustomMenuItem from "./CustomMenuItem";

type MenuAction = "delete" | "replace" | "download" | "rerun";
interface AudioMenuProps {
  onSelect: (action: MenuAction) => void;
}

const AudioMenu = ({ onSelect }: AudioMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (action: MenuAction) => {
    setAnchorEl(null);
    onSelect(action);
  };

  return (
    <>
      <ButtonGroup
        color="inherit"
        orientation="horizontal"
        variant="contained"
        sx={{ justifyItems: "center", alignItems: "center", backgroundColor: "#f7f8f8", height: "34px" }}
      >
        <Box sx={{ display: "flex", px: "10px", py: "5px", gap: 1, borderRight: 1, borderColor: "#e5e5ef" }}>
          <SpatialAudioOff sx={{ fontSize: "20px", color: "#003087" }} />
          <Typography sx={{ fontSize: "14px", fontWeight: "400", color: "#13294B" }}>AUDIO</Typography>
        </Box>
        <Button
          variant="text"
          color="primary"
          size="medium"
          sx={{ color: "#003087", height: "40px" }}
          id="basic-button"
          aria-controls={open ? "grouped-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <ArrowDropDown />
        </Button>
      </ButtonGroup>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{ paper: { sx: { width: "150px", px: "5px", display: "flex", flexDirection: "row" } } }}
      >
        <CustomMenuItem
          label="Download"
          Icon={FileDownloadOutlined}
          labelProps={{ sx: { color: "#003087" } }}
          onClick={() => {
            handleClose("download");
          }}
        />
        {/* <CustomMenuItem
        label="Rerun"
        Icon={ReplaySharp}
        labelProps={{ sx: { color: "#003087" } }}
        onClick={() => {
          handleClose("rerun");
        }}
      /> */}
        <Divider />
        {/* <CustomMenuItem
          label="Replace"
          Icon={RepeatSharp}
          labelProps={{ sx: { color: "red" } }}
          iconProps={{ sx: { color: "red" } }}
          onClick={() => {
            handleClose("replace");
          }}
        /> */}
        <CustomMenuItem // Possibly only have delete option for added but not-saved option?
          label="Delete"
          Icon={DeleteSharp}
          labelProps={{ sx: { color: "red" } }}
          iconProps={{ sx: { color: "red" } }}
          onClick={() => {
            handleClose("delete");
          }}
        />
      </Menu>
    </>
  );
};

export default AudioMenu;
